<template>

    <form ref="questao-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">

            <div class="form-group col-md-3">
                <label for="disciplinaId">Disciplina</label>
                <select v-select="{ dataitem: 'AuxDisciplina', default: 'Selecione' }" v-model="model.disciplinaId" class="form-control" name="disciplinaId" required></select>
            </div>
            <div class="form-group col-md-3">
                <label for="dificuldadeId">Dificuldade</label>
                <select v-select="{ dataitem: 'AuxDificuldade', default: 'Selecione' }" v-model="model.dificuldadeId" class="form-control" name="dificuldadeId" required></select>
            </div>
            <div class="form-group col-md-3">
                <label for="tipoRespostaId">Tipo da Resposta</label>
                <select v-select="{ dataitem: 'AuxTipoResposta', default: 'Selecione' }" disabled v-model="model.tipoRespostaId" class="form-control" name="tipoRespostaId" @change="carregaTipoResposta()" required></select>
            </div>
            <div class="form-group col-md-3">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ehAtivo" class="custom-control-input" v-model="model.ehAtivo">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Ativo?</span>
                </label>
            </div>

            <div class="col-md-12">
                <b-tabs>
                    <b-tab title="Enunciado" active>
                        <br />
                        <em>Caso você precise subir vídeos, favor não ultrapassar 2MB por vídeos/Audio</em>
                        <textarea v-model="model.enunciado" v-htmleditor></textarea>
                    </b-tab>

                    <b-tab title="Visualizar">
                        <br />
                        <div v-html="model.enunciado"></div>
                        <hr />
                    </b-tab>

                </b-tabs>
                <br />
            </div>

        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "questao-form-edit",
        mixins: [base],
        components: {},
        props: { id: Number },
        data: () => ({

            model: {

            },
            tipoResposta: {},

            form: "questao-form-edit",

            resources: {
                edit: 'questao',
            },


        }),

        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false) return;

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                var _valid = $form.checkValidity();
                if (!_valid) this.defaultErrorResult("Preencha todos os campos obrigatórios");
                return _valid;
            },

            onBack: function () {
                this.$emit('on-back')
            },

        },

        mounted() {
            new Api(this.resources.edit).get({ questaoId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>